module.exports = __webpack_public_path__ + "img/sample2-voronoi.e0d0b56a.png";